import {GET_FACET_DETAIL, GET_FACET_DETAIL_SUCCESS, GET_FACET_DETAIL_FAILURE} from '../constants'


const initialState = {
    facets: {

    },
    isFetching: false,
    error: false
};


export default (state = initialState, action) => {
    switch(action.type) {
        case GET_FACET_DETAIL:
            return {
                ...state,
                isFetching: true

            };
        case GET_FACET_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false,
                [action.facet]: action.records && action.records.suggestions ?
                    action.records.suggestions.map(d=>d) : [],
            };
        case GET_FACET_DETAIL_FAILURE:
            return {
                ...state,
                error:action.error

            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/facetDetail.js